// Utility function to detect and bold phone numbers in text
export const formatMessageWithBoldPhoneNumbers = (message: string) => {
  // Myanmar phone number patterns
  const phonePatterns = [
    /(\+?959\d{7,9})/g, // Myanmar international format
    /(\+?95\s?9\s?\d{3,4}\s?\d{3,4})/g, // Myanmar with spaces
    /(\b09\d{7,9})/g, // Myanmar local format
    /(\b\d{2,3}[-\s]?\d{3,4}[-\s]?\d{3,4})/g, // General phone pattern
  ];

  let formattedMessage = message;

  phonePatterns.forEach((pattern) => {
    formattedMessage = formattedMessage.replace(pattern, '<strong>$1</strong>');
  });

  return formattedMessage;
};
